import { GridColDef } from '@mui/x-data-grid';

export const audienceColumnConifg: GridColDef[] = [
  {
    field: 'firstName',
    headerName: 'First Name',
    minWidth: 200,
    valueGetter: async (value, row, column, apiRef) => {
      return (await row.getHashedAudience()).firstName;
    }
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    minWidth: 200,
    valueGetter: async (value, row, column, apiRef) => {
      return (await row.getHashedAudience()).lastName;
    }
  },
  {
    field: 'email',
    headerName: 'Email',
    minWidth: 200,
    valueGetter: async (value, row, column, apiRef) => {
      return (await row.getHashedAudience()).email;
    }
  },
  {
    field: 'phone',
    headerName: 'Phone',
    minWidth: 200,

    valueGetter: async (value, row, column, apiRef): Promise<string> => {
      return (await row.getHashedAudience()).phone;
    }
  },
  {
    field: 'country',
    headerName: 'Country',
    minWidth: 200,
    valueGetter: (value, row, column, apiRef) => {
      if (row.hashedAudience) {
        //look up 2 letter country code
        return row.hashedAudience.country;
      } else {
        return '';
      }
    }
  },
  {
    field: 'zip',
    headerName: 'Zip',
    minWidth: 200,
    valueGetter: (value, row, column, apiRef) => {
      if (row.shippingAddress) {
        return row.shippingAddress.postal.trim();
      } else {
        return '';
      }
    }
  }
];
